"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ErrorBoundary = _interopRequireDefault(require("../ErrorBoundary"));

var _Dropdown = _interopRequireDefault(require("../../../blocks/Dropdown"));

var _Button = _interopRequireDefault(require("../../../elements/Button"));

var _dropdownDownArrow = _interopRequireDefault(require("../../../icons/dropdown-down-arrow.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const LanguageButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "LanguageButton"
})(["font-size:0.625rem;color:", ";"], props => props.theme.palette.text);
const LanguageListWrap = (0, _styledComponents.default)(_Dropdown.default.ListWrap).withConfig({
  displayName: "LanguageListWrap"
})(["max-height:220px;overflow:auto;"]);
const LanguageListItem = (0, _styledComponents.default)(_Dropdown.default.ListItem).withConfig({
  displayName: "LanguageListItem"
})(["font-weight:normal;text-align:left;font-size:0.75rem;"]);

const Icon = _styledComponents.default.img.withConfig({
  displayName: "Icon"
})(["width:4px;height:4px;display:inline-block;transform:translateY(-2px) rotate(180deg);margin-left:0.25rem;"]);

class LanguageSelector extends _react.default.PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      open: false
    });

    _defineProperty(this, "_handleItemClick", language => {
      const _languageSelectHandler = this.props._languageSelectHandler;
      this.setState({
        open: false
      });

      _languageSelectHandler(language.lang);
    });

    _defineProperty(this, "_openList", () => {
      this.setState(prevState => ({
        open: !prevState.open
      }));
    });

    _defineProperty(this, "_populateList", languages => languages.map(language => /*#__PURE__*/_react.default.createElement(LanguageListItem, {
      key: language.name,
      onClick: () => {
        this._handleItemClick(language);
      }
    }, language.name)));

    _defineProperty(this, "_getLanguageName", lang => {
      const languagesArray = this.props.languagesArray;
      const currentLang = lang || 'en';
      return languagesArray.find(language => language.lang === currentLang).name;
    });
  }

  render() {
    const _this$props = this.props,
          languagesArray = _this$props.languagesArray,
          currentLang = _this$props.currentLang;
    const open = this.state.open;
    return /*#__PURE__*/_react.default.createElement(_ErrorBoundary.default, null, /*#__PURE__*/_react.default.createElement(_Dropdown.default, null, /*#__PURE__*/_react.default.createElement(LanguageButton, {
      modifiers: ['plain'],
      onClick: this._openList
    }, this._getLanguageName(currentLang), /*#__PURE__*/_react.default.createElement(Icon, {
      src: _dropdownDownArrow.default
    })), /*#__PURE__*/_react.default.createElement(LanguageListWrap, {
      open: open,
      modifiers: ['up']
    }, this._populateList(languagesArray))));
  }

}

LanguageSelector.propTypes = {
  _languageSelectHandler: _propTypes.default.func.isRequired,
  currentLang: _propTypes.default.string.isRequired,
  languagesArray: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    lang: _propTypes.default.string.isRequired
  })).isRequired
};
var _default = LanguageSelector;
exports.default = _default;